import store from '../../store.js';
let tempDate = new Date().getTime()

 export var paramsview = {
    title:"",
    efrom:"",
    ip:"",
    channel:"",
    systemversion:"",
    etype:"",
    systemname:"",
    udid:"",
    // createdate: tempDate,
    phone:"",
    mode:"",
    url:"",
    userId:"",
    referer: "",
	country:"",
	city:"",
    // productCode:"",
    // deviceBrand:"",
    // applicationId:"",
    // systemSdk:"",
    // imei:"",
    // outerMedia:"",
    // productId:0,
    // innerMedia:"",
    // mac:"",
    // power:"",
    // batterystatus:"",
    // deviceModel:"",
    // networktype:"",
    // gyo:"",
    // productversion:"",
    // idfa:"",
    // reallyChannel:"",
    // umDeviceToken:"",
    // umDeviceId:"",
    // umMac:"",
    // batteryType:0,
    // deviceModel:"",
}
export function setParamsIp(ip){
	paramsview.ip = ip || ""
}

export function setParamsUdid(udid){
	paramsview.udid = udid || ""
}

export function setParamsUserId(userId){
	paramsview.userId = userId || ""
}

export function setParamsJson(json){
	var _json = json
	
	if (_json != null || _json != '' || _json != undefined) {
	    paramsview.udid = _json.udid || "";
	    paramsview.phone = _json.phone || "";
	    paramsview.systemname = _json.systemname || "";
	    paramsview.efrom = _json.efrom || "";
	    paramsview.channel = _json.channel || "h5";
	    paramsview.systemversion = _json.systemversion || "";
	    paramsview.userId = _json.userId || "";
	    paramsview.url = window.location.href
		// #ifdef H5
		    paramsview.systemname = 'h5'
		// #endif
	    paramsview.ip = _json.ip || "";
		
		paramsview.referer = store.state.referer
	    // paramsview.ip = returnCitySN.cip
	    // paramsview.networktype = _json.networktype || "";
	    // paramsview.productversion = _json.productversion || "";
	    // paramsview.power = _json.power || 0;
	    // paramsview.gyo = _json.gyo || "";
	    // paramsview.batterystatus = _json.batterystatus || 0;
	    // paramsview.batteryType = _json.batteryType || 0;
	    // paramsview.innerMedia = _json.innerMedia || "";
	    // paramsview.outerMedia = _json.outerMedia || "";
	    // paramsview.mac = _json.mac || "";
	    // paramsview.imei = _json.imei || "";
	    // paramsview.idfa = _json.idfa || "";
	    // paramsview.androidId = _json.androidId || "";
	    // paramsview.deviceBrand = _json.deviceBrand || "";
	    // paramsview.deviceModel = _json.deviceModel || "";
	    // paramsview.productId = _json.productId || 0;
	    // paramsview.systemSdk = _json.systemSdk || "";
	    // paramsview.applicationId = _json.applicationId || "";
	    // paramsview.productCode = _json.productCode = "";
	    // paramsview.referer = _json.referer || "";
	    // paramsview.reallyChannel = _json.reallyChannel || "";
	    // paramsview.umDeviceToken = _json.umDeviceToken || "";
	    // paramsview.umMac = _json.umMac || "";
	}
}